import useOpenSmartviews from 'components/generic/smartview/shared/hooks/useOpenSmartviews';
import useSmartviewManager from 'components/generic/smartview/shared/hooks/useSmartviewManager';
import type { ISmartSideDrawerView } from 'components/generic/smartview/smartviewSideDrawer/shared/types';
import useUncommittedSearchParams from '../../../../shared/hooks/useUncommittedSearchParams';
import { rootMenuId } from '../../../Filters/RootFilter/RootFilterMenu';
import { useSearchQuery } from '../../../Search/shared/hooks/useFilterOptionsBySearchQuery';

/**
 * A hook for interacting with Filter Menus
 * @param menuId
 * @returns
 */
export default function useFilterMenu(menuId: ISmartSideDrawerView['name'], openRoot = true) {
    const openSmartviews = useOpenSmartviews(true, 'right');
    const { close } = useSmartviewManager(menuId);
    const { resetUncommittedSearchParams } = useUncommittedSearchParams();
    const [, setSearchQuery] = useSearchQuery();

    const openFilterMenu = () => {
        // we need to keep track of the Url Search params before we opened the menu. We use it to revert if filters are changed but not applied.
        resetUncommittedSearchParams();
        setSearchQuery('');

        if (menuId === rootMenuId) {
            openSmartviews([rootMenuId]);
            return;
        }

        // Always open the root menu first
        if (openRoot) {
            openSmartviews([rootMenuId, menuId]);
        } else {
            openSmartviews([menuId]);
        }
    };

    return { openFilterMenu, closeFilterMenu: close };
}
